<template>
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <div v-else>
        <v-layout wrap>
            <v-flex xs12>
                <v-alert :value="error != null" outline type="error">
                    {{ error }}
                </v-alert>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
                <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
                <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm2 offset-sm1>
                <v-btn color="primary" block @click="showEditAddBurro({ IsActive: true })">
                    Add
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]" :headers="headers" :items="filteredItems" :search="search">
                    <template v-slot:items="{ item }">
                        <td>{{ item.DeviceID }}</td>
                        <td>{{ item.Name }}</td>
                        <td>{{ item.Description }}</td>
                        <td>{{ item.PlantName }}</td>
                        <td>{{ item.LastDateUsed | formatDate }}</td>
                        <td>{{ item.LastTeamName ? item.LastTeamPlantName + "/" + item.LastTeamName : "" }}</td>
                        <td>{{ item.Comments }}</td>
                        <td>{{ item.IsActive ? 'Active' : 'Inactive' }}</td>
                        <td>
                            <v-btn color="primary" block @click="showEditAddBurro(item)">
                                <span>Edit</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-dialog :value="editing" fullscreen hide-overlay transition="dialog-bottom-transition">
            <BurroEdit v-if="editing" :item="editItem" :plantList="plantList" :submitLoading="loading" :submitError="error"
                @submit="handleSubmit" @cancel="cancelEdit()">
            </BurroEdit>
        </v-dialog>
    </div>
</template>
    
<script>
import BurroEdit from "@/components/configuration/assets/BurroEdit.vue";
import AssetApi from '@/api/assetApi';
import PlantApi from '@/api/plantApi';

export default {
    components: {
        BurroEdit: BurroEdit
    },
    data() {
        return {
            editing: false,
            error: null,
            search: "",
            loading: false,
            activeOnly: true,
            editItem: null,
            burros: [],
            plantList: [],
            headers: [
                {
                    text: "Device ID",
                    value: "DeviceID",
                    sortable: true
                },
                {
                    text: "Asset Name",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Asset Description",
                    value: "Description",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "PlantName",
                    sortable: true
                },
                {
                    text: "Last Date Used",
                    value: "LastDateUsed",
                    sortable: true
                },
                {
                    text: "Last Plant-Team",
                    sortable: false
                },
                {
                    text: "Comments",
                    value: "Comments",
                    sortable: true
                },
                {
                    text: "Active",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "DeviceID",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        filteredItems() {
            if (!this.activeOnly) {
                return this.burros;
            }
            return this.burros.filter(c => c.IsActive);
        }
    },
    methods: {
        async loadBurros() {
            this.loading = true;
            this.error = null;

            try {
                this.burros = await AssetApi.getBurros();
            } catch (err) {
                this.error = err;
            }

            this.loading = false;
        },
        showEditAddBurro(item) {
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.error = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            if (this.burros.filter(a => a.DeviceID == item.DeviceID && a.BurroID !== item.BurroID).length > 0) {
                this.error = "Burros with the same Device ID already exists."
                return;
            }

            this.loading = true;
            try {
                let response = {};

                if (item.BurroID > 0) {
                    response = await AssetApi.updateBurro(item);
                } else {
                    response = await AssetApi.addBurro(item);
                }

                if (!response.Success) {
                    this.error = response.ErrorMessages.join(', ');
                    return;
                }

                this.editing = false;
            } catch (err) {
                this.error = err;
                return;

            } finally {
                this.loading = false;
            }
            await this.loadBurros();
        }
    },
    async created() {
        await this.loadBurros();

        let plants = await PlantApi.getAllPlants();
        this.plantList = plants.map(x => {
            return {
                PlantID: x.PlantID,
                PlantName: x.PlantName
            };
        });
    }
}
</script>
    